

class Core {
    constructor() {
        this.currentTimeout = null;
    };
    wait(timeout) {
        if (this.currentTimeout) {
            clearTimeout(this.currentTimeout);
        };
        return new Promise(resolve => {
            this.currentTimeout = setTimeout(resolve, timeout);
        });
    };
};

window.addEventListener("load", function () {
    // Burger menu toggle
    const btnBurger = document.querySelector('.btn_buger');
    const burgerInfo = document.querySelector('.burger-info');
    
    if (btnBurger && burgerInfo) {
        btnBurger.addEventListener('click', function() {
            btnBurger.classList.toggle('active');
            burgerInfo.classList.toggle('active');
        });
        
        // Close burger-info when clicking on links inside it
        const burgerLinks = burgerInfo.querySelectorAll('a');
        burgerLinks.forEach(function(link) {
            link.addEventListener('click', function() {
                btnBurger.classList.remove('active');
                burgerInfo.classList.remove('active');
            });
        });
    }
});
